export default __webpack_public_path__ + "img/vue.43bd93a8.jpg";